module.exports = __webpack_public_path__ + "static/media/gh-animated-logo.svg";